import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=51dfb5d2&scoped=true"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=51dfb5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dfb5d2",
  null
  
)

export default component.exports